$(document).ready(function() {
  $('.rte > *').each(function() {
    const text = $(this).text()

    if (text == '[box]') {
      $(this).replaceWith('<div data-el="box">')
    } else if (text == '[/box]') {
      $(this).replaceWith('<div data-el-end="box">')
    } else if (text == '[product]') {
      $(this).replaceWith(`
        <a href="https://bacecollective.com/products/discovery-path" class="rte-product">
          <span class="rte-product-image">
            <img src="https://cdn.shopify.com/s/files/1/0269/6488/5581/products/product-image.png?v=1584400708" />
          </span>
          <span class="rte-product-text">
            <h2>Bace Discovery Kit</h2>
            <p>This 7-day guided experience will help you discover what dosage is right for you.</p>
            <p class="rte-product-price">
              $40
              <svg viewBox="0 0 60 25" width="60px"><path d="M0 13.088v-2h56.213l-9.606-9.607L48.02.067l12.02 12.021-12.02 12.02-1.414-1.415 9.604-9.605z" fill="currentColor" fill-rule="nonzero"/></svg>
            </p>
          </span>
        </a>
      `)
    }
  })

  $('.rte').each(function() {
    let text = $(this)
      .html()
      .toString()

    text = text.split('<div data-el="box"></div>').join('<div class="box">')
    text = text.split('<div data-el-end="box"></div>').join('</div>')

    $(this).html(text)
  })
})
